import { ActionReducerMap, createFeatureSelector } from '@ngrx/store';
import { IFlightClassResponse } from '@shared/shared/interfaces/travel-flight.interfaces';
import * as fromFlightClassesReducer from './flight-classes.reducers';
import * as fromHotelClassesReducer from './hotel.reducers';

// Flight
export interface FlightSearchDataState {
  flightClasses: Array<IFlightClassResponse>;
}

export const flightReducers: ActionReducerMap<FlightSearchDataState> = {
  flightClasses: fromFlightClassesReducer.reducer,
};

export const getFlightSearchDataState = createFeatureSelector<FlightSearchDataState>('flight-search-data');

// Hotel
export interface HotelSearchDataState {
  selectedLayout: string;
}

export const hotelReducers: ActionReducerMap<HotelSearchDataState> = {
  selectedLayout: fromHotelClassesReducer.reducer,
};

export const getHotelSearchDataState = createFeatureSelector<HotelSearchDataState>('hotel-search-data');
